import { useHistory } from "react-router-dom";
import { client } from "../../hooks/Client.js";

const PremiumContainer = ({text}) => {
  const history = useHistory();

  return (
    <div id='premium-container'>
        <h1>Dit is een premium functionaliteit</h1>
        <p>{text}</p>
        <p>Upgrade nu naar premium om deze functionaliteit te gebruiken.</p>
        <button onClick={() => history.push(`/${client}/subscription`)}>Upgrade</button>
    </div>
  )
}

export default PremiumContainer